import { Injectable, signal } from '@angular/core';
import {
  FormStatus,
  FormSubmission,
  FormsSubmissionsParams,
  FormType,
} from '@models';
import { Observable, of } from 'rxjs';
import { FormsService } from './forms.interface';

@Injectable({
  providedIn: 'root',
})
export class FormsServiceMock implements FormsService {
  searchResultForms = signal<FormSubmission[]>([]);

  private mockForms: FormSubmission[] = [
    {
      id: '1',
      templateName: 'Consent Form A',
      patientName: 'John Doe',
      providerName: 'Dr. Smith',
      formStatus: FormStatus.Sent,
      createdAt: new Date().toISOString(),
      formType: 'ConsentForm',
    },
    {
      id: '2',
      templateName: 'Consent Form A',
      patientName: 'John Doe',
      providerName: 'Dr. Smith',
      formStatus: FormStatus.Opened,
      createdAt: new Date().toISOString(),
      updatedAt: null,
      formType: 'ConsentForm',
    },
    {
      id: 'sent-mock-submission-1',
      templateName: 'Smart Form A',
      patientName: 'Jane Roe',
      providerName: 'Dr. Adams',
      formStatus: FormStatus.Sent,
      createdAt: new Date().toISOString(),
      formType: 'SmartForm',
    },
    {
      id: 'opened-mock-submission-1',
      templateName: 'Smart Form',
      patientName: 'Alice Johnson',
      providerName: 'Dr. Brown',
      formStatus: FormStatus.Opened,
      percentageScore: 80,
      createdAt: new Date().toISOString(),
      formType: 'SmartForm',
    },
    {
      id: 'intake-mock-submission-1',
      templateName: 'intake-form-template-v1',
      patientName: 'John Doe',
      providerName: 'Dr. Smith',
      formStatus: FormStatus.Completed,
      createdAt: new Date().toISOString(),
      formType: 'IntakeForm',
    },
  ];

  getForms(params: FormsSubmissionsParams = {}): Observable<FormSubmission[]> {
    const limit = params.limit ?? 10;
    let items = this.mockForms.slice(0, limit);

    if (params.type && params.type !== 'All')
      items = items.filter(i => i.formType === params.type);

    if (params.status) {
      items = params.excludeStatus
        ? items.filter(i => i.formStatus !== params.status)
        : items.filter(i => i.formStatus === params.status);
    }

    return of(items);
  }

  getPatientFormsSubmissions(
    patientId: string,
    params?: { limit?: number; type?: FormType | 'All' }
  ): Observable<FormSubmission[]> {
    let items = this.mockForms;

    if (params?.type && params.type !== 'All')
      items = items.filter(i => i.formType === params.type);

    return of(items.slice(0, params?.limit ?? items.length));
  }
}
